import { AnyAction } from "redux";
import { FindById, Update } from "../../../groups";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { GroupAdapter } from "../../../../adapter/groups-adapter";

export const FETCH_UPDATE_GROUP_REQUEST = 'FETCH_UPDATE_GROUP_REQUEST';
export const FETCH_UPDATE_GROUP_SUCCESS = 'FETCH_UPDATE_GROUP_SUCCESS';
export const FETCH_UPDATE_GROUP_FAILURE = 'FETCH_UPDATE_GROUP_FAILURE';
export const SET_UPDATE_GROUP = 'SET_UPDATE_GROUP';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchUpdateGroupRequest = () => {
    return {
        type: FETCH_UPDATE_GROUP_REQUEST,
    };
};

const fetchUpdateGroupSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_UPDATE_GROUP_SUCCESS,
        payload: data
    };
};

const fetchUpdateGroupFailure = (error: any) => {
    return {
        type: FETCH_UPDATE_GROUP_FAILURE,
        payload: error,
    };
};

export const setUpdateGroup = (data: any) => {
    return {
        type: SET_UPDATE_GROUP,
        payload: data,
    };
};

export const update = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateGroupRequest());
        try {
            const response = await Update(id, data);
            dispatch(fetchUpdateGroupSuccess(
                Adapter.from(response.data).to((value) => new GroupAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchUpdateGroupFailure(error.message));
        }
    };
};

export const findById = (id: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchUpdateGroupRequest());
        try {
            const response = await FindById(id, 'fields=*.*');
            dispatch(setUpdateGroup(
               response.data
            ));
        } catch (error: any) {
            dispatch(fetchUpdateGroupFailure(error.message));
        }
    };
};
